import { render, staticRenderFns } from "./YourPeople.vue?vue&type=template&id=47e7880f&scoped=true"
import script from "./YourPeople.vue?vue&type=script&lang=js"
export * from "./YourPeople.vue?vue&type=script&lang=js"
import style0 from "./YourPeople.vue?vue&type=style&index=0&id=47e7880f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7880f",
  null
  
)

export default component.exports